<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app>
    <div style="background-color: #E7F2F9;">
      <v-main class="d-flex align-center justify-center" style="height: 100vh; background-color: #E7F2F9;">
        <v-card class="pa-6" max-width="390" elevation="4" rounded>
          <v-card-title class="justify-center pb-4">
            <img 
              src="../assets/sicon.png" 
              height="300" 
              style="margin-top: 20px !important; display: block;"
            />
          </v-card-title>

          <v-card-subtitle class="text-center text-h6 font-weight-bold mb-6" style="color: var(--color-primary);">
            Entrar no Sistema
          </v-card-subtitle>

          <v-form @submit.prevent="handleLogin" ref="form" lazy-validation>
            <v-text-field
              v-model="email"
              label="E-mail"
              type="email"
              required
              outlined
              dense
              :rules="[rules.required, rules.email]"
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="password"
              label="Senha"
              type="password"
              required
              outlined
              dense
              :rules="[rules.required]"
              class="mb-6"
            ></v-text-field>

            <v-btn
              type="submit"
              block
              color="success"
              class="mb-4"
              elevation="2"
              :loading="loading"
            >
              Entrar
            </v-btn>
          </v-form>
        </v-card>
      </v-main>
    </div>
  </v-app>
</template>

<script setup>
import { ref } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'

const email = ref('')
const password = ref('')
const loading = ref(false)
const form = ref(null)
const auth = useAuthStore()
const router = useRouter()

const rules = {
  required: value => !!value || 'Campo obrigatório.',
  email: value => /.+@.+\..+/.test(value) || 'E-mail inválido.'
}

async function handleLogin() {
  loading.value = true
  try {
    const response = await auth.login(email.value, password.value)

    if (!response.user?.status) {
      alert('VOCÊ NÃO ESTÁ ATIVO')
      return
    }

    // ✅ Redireciona para o dashboard (sem sair do front)
    router.push('/dashboard')
  } catch (err) {
    const message = err.response?.data?.message || 'Login e senha inválidos'
    alert(message)
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
:root {
  --color-primary: #234a64;
  --color-bg-light: #E7F2F9;
}
</style>
